import * as React from "react";
// import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./MainLayout";
import Onproducts from "./Pages/Onproducts";
import Companymemo from "./Pages/Companymemo";
import Preloader from "./Components/Preloader";
import ContactPage from "./Pages/ContactPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
  },
  {
    path: "products",
    element: <Onproducts />,
  },
  {
    path: "gallary",
    element: <Companymemo />,
  },
  {
    path: "contact",
    element: <ContactPage />,
  },
]);

const App = () => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Change this to the time you want your preloader to show (in ms)

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default App;
